import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { SapService } from 'src/app/api/sap.service';
import Swal from 'sweetalert2';
import { CrearOportunidadComponent } from '../../oportunidad/crear-oportunidad/crear-oportunidad.component';
import { variableGlobal } from 'src/app/global.enum';

@Component({
  selector: 'app-seguimiento-oportunidad',
  templateUrl: './seguimiento-oportunidad.component.html',
  styleUrls: ['./seguimiento-oportunidad.component.sass', "./seguimiento-oportunidad.component.css"]
})
export class SeguimientoOportunidadComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _api: IntranetoldService,
    private _sap: SapService,
  ) { }

  data: any;
  documento: any;
  desdeVenta: any;
  Etapas: any;
  public configuration: Config;
  public columns: Columns[];
  listaVendedor: any;
  cargando: boolean = false;
  oportunidadSeleccionada: any;
  oportunidadOPR1: any =
    {
      "OpprId": -1,
      "Line": -1,
      "SlpCode": -1,
      "CntctCode": null,
      "Step_Id": 1,
      "ClosePrcnt": 0,
      "MaxSumLoc": 0,
      "MaxSumSys": 1.0,
      "Memo": "",
      "DocId": null,
      "ObjType": "-1",
      "Status": "O",
      "Linked": "false",
      "WtSumLoc": 0,
      "WtSumSys": 1.0,
      "UserSign": null,
      "ChnCrdCode": null,
      "ChnCrdName": null,
      "ChnCrdCon": null,
      "DocChkbox": null,
      "Owner": null,
      "DocNumber": null,
      "EncryptIV": null,
      "userFields": []
    };

  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;
  @ViewChild('frmCreateDate', { static: true }) frmCreateDate: TemplateRef<any>;
  @ViewChild('frmPredDate', { static: true }) frmPredDate: TemplateRef<any>;
  @ViewChild('frmCloPrcnt', { static: true }) frmCloPrcnt: TemplateRef<any>;
  @ViewChild('frmSlpCode', { static: true }) frmSlpCode: TemplateRef<any>;
  @ViewChild('frmStepLast', { static: true }) frmStepLast: TemplateRef<any>;

  async ngOnInit(): Promise<void> {

    await this.cargaOportunidades();
    await this.cargaEtapas();
    
    
    

  }

  async cargaOportunidades() {
    let query = await this.obtieneQueryMongo('Oportunidades');
    this.data = await this._api.GetNotFileQuery(query);
    this.data = [...this.data.objeto];

    let listaVendedor: any = await this.obtieneQueryMongo('listaVendedor');
    listaVendedor = await this._api.GetNotFileQuery(listaVendedor);
    this.listaVendedor = listaVendedor.objeto;

    

    

    this.data = this.data.filter(i => i.CardCode == this.documento.CardCode);

    this.data.sort((a, b) => new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime());

    

    this.columns = [
      { key: '', title: 'Acción', cellTemplate: this.frmAccion },
      { key: 'OpprId', title: 'N°' },
      { key: 'Name', title: 'Oportunidad' },
      { key: 'CardName', title: 'Empresa' },
      //  { key: 'CardCode', title: 'Persona de Contacto' },
      { key: 'CreateDate', title: 'Fecha Creación', cellTemplate: this.frmCreateDate },
      { key: 'PredDate', title: 'Fecha Cierre', cellTemplate: this.frmPredDate },
      { key: 'MaxSumLoc', title: 'Monto' },
      { key: 'CloPrcnt', title: 'Progreso', cellTemplate: this.frmCloPrcnt },
      { key: 'StepLast', title: 'Estado', cellTemplate: this.frmStepLast },
      { key: 'SlpCode', title: 'Vendedor', cellTemplate: this.frmSlpCode },
    ];

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: true,
      paginationRangeEnabled: true,
      paginationEnabled: true,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };

  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });
    return query;
  }

  cerrar() {
    this.activeModal.close();
  }

  async cargaEtapas() {

    let Etapas: any = await this.obtieneQueryMongo('OportunidadEtapas');
    Etapas = await this._api.GetNotFileQuery(Etapas);
    this.Etapas = Etapas.objeto;

    this.Etapas.forEach(element => {
      element.oportunidades = [];
    });

    this.Etapas.forEach(etapa => {
      this.data.forEach(item => {
        if (item.StepLast == etapa.StepId) {
          etapa.oportunidades.push(item);
        }
      });
    });


  }

  limiteCloseDate: any;
  async seleccionarOportunidad(row: any) {

    this.cargando = true;

    

    let res: any = await this._sap.obtieneOportunidad(row.OpprId);

    if (res.estado) {

      

      this.oportunidadSeleccionada = res.resultado;

      

      this.oportunidadOPR1.OpprId = this.oportunidadSeleccionada.OpprId;
      this.oportunidadOPR1.MaxSumLoc = this.documento.GrossProfit;
      this.oportunidadOPR1.ObjType = this.documento.ObjType;
      this.oportunidadOPR1.DocId = this.documento.DocNum;

      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'success',
        title: 'Oportunidad Seleccionada'
      });

    }
    else {

      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'error',
        title: res.mensaje
      });

    }





    

    this.cargando = false;

  }

  limpiarOportunidad() {
    this.oportunidadSeleccionada = null;
  }

  async crearOportunidad() {

    
    this.oportunidadOPR1.Step_Id = Number(this.oportunidadOPR1.Step_Id)
    this.oportunidadSeleccionada.OPR1.push(this.oportunidadOPR1);

    if (!this.desdeVenta) {
      this.cargando = true;

      let res:any = await this._sap.creaActualizaOportunidad(this.oportunidadSeleccionada);

      if (res.estado) {

        window.location.href = '/Oportunidad/Detalle/' + this.oportunidadSeleccionada.OpprId;

        this.cargando = false;

        Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).fire({
          icon: 'success',
          title: "Oportunidad creada con éxito!"
        });


      }
      else {
        this.cargando = false;

        Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).fire({
          icon: 'error',
          title: res.mensaje
        });
      }
    }
    else {
      this.activeModal.close(this.oportunidadSeleccionada);
    }

  }

  crearOportunidadTabla() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      animation: true,
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearOportunidadComponent, ngbModalOptions);
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.crear = true;
    modalRef.componentInstance.crearDesdeSegumiento = true;
    modalRef.componentInstance.documento = this.documento;

    modalRef.result.then(async (data) => {
      await this.cargaOportunidades();
      await this.cargaEtapas();
    });
  }


  obtenerFechaActualEnFormato(date?): string {

    let fecha = new Date();

    if (date) {
      fecha = new Date(date)
    }

    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes comienza desde 0
    const dia = fecha.getDate().toString().padStart(2, '0');
    const horas = '00';
    const minutos = '00';
    const segundos = '00';

    const fechaFormateada = `${año}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    return fechaFormateada;
  }


  pruebaclose() {

    

  }

}
